import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import getSymbolFromCurrency from 'currency-symbol-map'
import Modal from 'react-bootstrap-modal'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.css'
import { Loader } from '../UI'
import { ALL_LANGUAGES } from './../../constants'
import moment from 'moment'
import _ from 'lodash'
import 'moment-recur'

import Map from '../POIForm/Map'
import EventDatesModal from './EventDatesModal'

import LOCAL_TOUR from '../../graphql/Activity/LocalTour.graphql'
import USER_QUERY from './../../graphql/User.graphql'
import StarRatingComponent from 'react-star-rating-component'

import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import { SocialIcon } from 'react-social-icons'
import whatsappIcon from '../../../public/img/GuruProfile/whatsapp.svg'
import copyLinkIcon from '../../../public/img/GuruProfile/copyLink.png'
import SingleChat from '../Chat/SingleChat'
import { showSignup } from '../../libs/authService';

const host = '//' + window.location.hostname + (window.location.port != 80 ? ':' + window.location.port : '')

class ActivityOverview extends Component {
  state = {
    eventDates: [],
    isShowShareModal: false,
    events: [],
    chatIsOpend: false,
    privateShown: false
  }

  componentWillReceiveProps(nextProps) {
    const localTour = _.head(nextProps.localTour.localTour)
    localTour &&
      this.setState(
        {
          eventDates: localTour.tourDates
        },
        this.createDates
      )
  }

  createDates = () => {
    const events = []
    const repeatingDates = this.state.eventDates.filter(item => {
      if ((!item.repeatDays || item.repeatDays.length == 0) && moment().isBefore(item.eventDate)) {
        events.push(item.eventDate)
      }
      return item.repeatDays.length > 0 && (!item.endRepeat || item.endRepeat && moment().isBefore(item.endRepeat))
    })
    // Claculate repeating dates
    repeatingDates.map(item => {
      let startOfEvent = moment(item.eventDate)
      const daysOfWeek = this.createDaysOfWeek(item.repeatDays)
      let now = moment()
      let indexDate = now.set({hour: startOfEvent.hour(), minute: startOfEvent.minute(), second: 0});
      if (indexDate.isBefore(now)) {
        indexDate = indexDate.add(1, 'days')
      }
      
      let endOfRepeat = item.endRepeat ? moment(item.endRepeat) : moment(new Date()).add(1, 'y')
      do {
        let selectedDates = daysOfWeek.map(dayINeed => {
            let curDate = moment(indexDate)
          // if we haven't yet passed the day of the week that I need:
            if (curDate.isoWeekday() <= dayINeed) { 
              // then just give me this week's instance of that day
              return curDate.isoWeekday(dayINeed).toDate()
          } else {
            // otherwise, give me next week's instance of that day
              return curDate.add(1, 'weeks').isoWeekday(dayINeed).toDate()
          }
        })
        indexDate.add(1, 'weeks')
        events.push(...selectedDates)
      }
      while(indexDate.isBefore(endOfRepeat))
    })
    const sortedEvents = events.sort((left, right) => {
      return moment(left).diff(right)
    })
    this.setState({
      events: _.uniqBy(sortedEvents, e => e)
    })
  }

  updateState(data) {
    this.setState(data)
  }

  createDaysOfWeek = (arr = []) => {
    const days = []
    arr.forEach(item => {
      switch (item) {
        case 'Mon':
          days.push(1)
          break
        case 'Tue':
          days.push(2)
          break
        case 'Wed':
          days.push(3)
          break
        case 'Thu':
          days.push(4)
          break
        case 'Fri':
          days.push(5)
          break
        case 'Sat':
          days.push(6)
          break
        case 'Sun':
          days.push(7)
          break
        default:
          break
      }
    })
    return days
  }

  closeModal = () => {
    this.setState({
      datesModalOpen: false
    })
  }

  showDatesModal() {
    this.setState({
      datesModalOpen: true
    })
  }

  searchLanguaegs = langId => {
    return ALL_LANGUAGES.filter(lang => {
      if (lang['1'] === langId) {
        return lang.name
      } else {
        return null
      }
    })
  }

  renderLanguages = languages => {
    if (!languages) return ''
    let string
    if (languages.length > 1) {
      const langArray = languages.map(langId => _.head(this.searchLanguaegs(langId)).name)
      string = langArray.slice(0, -1).join(', ') + ' and  ' + langArray[langArray.length - 1]
    } else {
      string = ALL_LANGUAGES[_.head(languages)]
    }
    return string
  }

  goToActivityBooking = date => {
    this.props.updateState({
      chosenDate: date
    })
    this.props.history.push(`/activity-booking-steps/${this.props.match.params.id}`)
  }

  handleShare = () => {
    this.handleShow()
  }

  handleShow = () => {
    this.setState({ isShowShareModal: true })
  }

  handleClose = () => {
    this.setState({ isShowShareModal: false })
  }

  handleClipBoard = text => {
    document.addEventListener('copy', e => {
      e.clipboardData.setData('text/plain', text)
      e.preventDefault() // default behaviour is to copy any selected text
    })

    document.execCommand('copy')

    this.setState({
      isSuccess: true,
      currentLink: text
    })
  }

  handleOpenChat = () => {
    this.setState({
      chatIsOpend: !this.state.chatIsOpend
    })
  }

  closeChat = () => {
    this.setState({
      chatIsOpend: false
    })
  }

  copySuccess = () => {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: 15,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-around'
        }}
      >
        {`Link copied`}
        <code>{this.state.currentLink}</code>
      </div>
    )
  }

  handleSeeDatesClick = () => {
    if (!this.props.userProfile.user) {
      // No user logged in
      showSignup(window.location.pathname)
    }
    else {
      this.showDatesModal()
    }
  }

  renderModal = () => {
    return (
      <Modal
        show={this.state.isShowShareModal}
        onHide={this.handleClose}
        className="copy-modal"
        aria-labelledby="ModalHeader"
        style={{ paddingBottom: 25 }}
      >
        <Modal.Header closeButton={true}>
          <Modal.Title
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around'
            }}
          >
            Share it with your friends
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around',
              paddingBottom: 15
            }}
          >
            <div>
              <FacebookShareButton url={`${host}${this.props.history.location.pathname}`}>
                <SocialIcon network="facebook" color="#4168AD" />
              </FacebookShareButton>
            </div>
            <div>
              <TwitterShareButton
                //title={ this.props.guruId ? `${host}/gurus/guru-profile/${this.props.guruId}` : `${host}/gurus/guru-profile/${this.props.user.id}`}
                url={`${host}${this.props.history.location.pathname}`}
                hashtags={['GetTrip.Guru']}
              >
                <SocialIcon network="twitter" color="#00A2EC" />
              </TwitterShareButton>
            </div>
            <div>
              <WhatsappShareButton url={`${host}${this.props.history.location.pathname}`} hashtags={['Trippere']}>
                <img src={whatsappIcon} alt="" style={{ width: 50, height: 50 }} />
              </WhatsappShareButton>
            </div>
            <div style={{ cursor: 'pointer' }}>
              <img
                src={copyLinkIcon}
                alt=""
                style={{ width: 50, height: 50 }}
                onClick={() => this.handleClipBoard(`${host}${this.props.history.location.pathname}`)}
              />
            </div>
          </div>

          {this.state.isSuccess && this.copySuccess()}
        </Modal.Body>
      </Modal>
    )
  }

  render() {
    const { t } = this.props

    if (this.props.userProfile.loading || this.props.localTour.loading) {
      return <Loader showLoader={true} />
    }

    const localTour = _.head(this.props.localTour.localTour)
    console.log('localTour', localTour);

    if (localTour) {
      let circle = {
        //lat: localTour.meetingPoint.lat ? localTour.meetingPoint.lat : null,
        //lng: localTour.meetingPoint.lng ? localTour.meetingPoint.lng : null,
        lat: localTour.tourLocation.lat,
        lng: localTour.tourLocation.lng,
        radius: 200,
        options: { fillColor: '#33b3de', strokeColor: '#33b3de' }
      }

      return (
        <div className="row overview custom-overview">
          <div className="col-lg-8 col-md-8 col-sm-7 main-info" style={{ maxWidth: 700, marginLeft: 'unset' }}>
            <div className="main-info-wrapper">
              <div className="row summary__item tour__title">
                <div className="icons guru-profile__header-icons">
                  <span className="icon-email" onClick={this.handleOpenChat} />
                  <span className="icon-share" onClick={this.handleShare} />
                  <span className="icon-like" />
                  {this.state.chatIsOpend && (
                    <SingleChat user={this.props.user} recipientId={localTour.tripGuide.id} handleOpenChat={this.handleOpenChat} />
                  )}
                </div>
                <h1 className="tour-title">{localTour.title}</h1>
                <div>
                  <div className="categories__item">
                    <span>{localTour.tourLocation && localTour.tourLocation.description}</span>
                  </div>
                  <div className="categories__item">
                    <span>{JSON.parse(localTour.categories) && JSON.parse(localTour.categories).map((item, index) => <span key={index}>{item}</span>)}</span>
                  </div>

                  <div className="guide__item">
                    <div>
                      <span>Activity by </span>
                      <span>{localTour && localTour.tripGuide.userProfile.firstName}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row summary__item tour__item">
                <img
                  className="guide__img"
                  src={
                    localTour &&
                    localTour.tripGuide.userProfile[0] &&
                    localTour.tripGuide.userProfile[0].imageAvatar &&
                    localTour.tripGuide.userProfile[0].imageAvatar.s3Url
                      ? localTour.tripGuide.userProfile[0].imageAvatar.s3Url
                      : ''
                  }
                  alt=""
                />

                {localTour.shortDescription}
              </div>

              <div className="summary__item">
                <div className="summary__item__key">
                  <span className="summary__item__subtitle">Tour duration: </span>
                  {`${localTour.estimatedDurationHours} hours`}
                </div>

                <div className="summary__item__key">
                  <span className="summary__item__subtitle">Offered in: </span>
                  {this.renderLanguages(JSON.parse(localTour.languages))}
                </div>

                <div className="summary__item__key">
                  <span className="summary__item__subtitle">{t('what_i_provide')}: </span>

                  {localTour.whatWeProvide}
                </div>

                <div className="summary__item__key">
                  <span className="summary__item__subtitle">Group Size: </span>

                  {`${localTour.minGroupSize}-${localTour.maxGroupSize}`}
                </div>
              </div>

              <div className={localTour.whatWeDo ? 'summary__item' : 'hidden'}>
                <div className="summary__item__title">{t('what_we_do')}</div>
                <div>
                  <span className="summary__item__value">{localTour.whatWeDo}</span>
                </div>
              </div>

              <div className={localTour.whereWeBe ? 'summary__item' : 'hidden'}>
                <div className="summary__item__title">{t('where_will_be')}</div>
                <div>
                  <span className="summary__item__value">{localTour.whereWeBe}</span>
                </div>
              </div>

              <div className={localTour.whatYouProvide ? 'summary__item' : 'hidden'}>
                <div className="summary__item__title">{t('what_i_provide')}</div>
                <div>
                  <span className="summary__item__value">{localTour.whatYouProvide}</span>
                </div>
              </div>

              <div className={localTour.whatYouBring ? 'summary__item' : 'hidden'}>
                <div className="summary__item__title">{t('what_bring')}</div>
                <div>
                  <span className="summary__item__value">{localTour.whatYouBring}</span>
                </div>
              </div>

              <div className={localTour.securityNotice ? 'summary__item' : 'hidden'}>
                <div className="summary__item__title">{t('security_notice')}</div>
                <div>
                  <span className="summary__item__value">{localTour.securityNotice}</span>
                </div>
              </div>

              <div className={localTour.weatherNotice ? 'summary__item' : 'hidden'}>
                <div className="summary__item__title">{t('weather_notice')}</div>
                <div>
                  <span className="summary__item__value">{localTour.weatherNotice}</span>
                </div>
              </div>

              <div className={localTour.tags ? 'summary__item tags-wrapper' : 'hidden'}>
                {localTour.tags
                  ? localTour.tags.map((tag, index) => (
                      <div className="activity-summary__tags__tag" key={index}>
                        {tag.value}
                      </div>
                    ))
                  : ''}
              </div>

              <div className={localTour.meetingPoint ? 'map__item' : 'hidden'}>
                <div className="summary__item__title">Where we'll meet</div>
                <div>
                  <Map
                    defaultZoom={16}
                    containerElement={<div className="google-map__container" />}
                    mapElement={<div className="google-map__element" />}
                    createRef={map => {
                      this.map = map
                    }}
                    ref={map => (this.map = map)}
                    center={localTour.meetingPoint}
                    circle={circle}
                  />
                </div>
              </div>

              <div className="reviews">
                <div className="summary__item__title">{localTour.userReviews ? localTour.userReviews.length + ' Reviews' : ''}</div>

                <div className="reviews__item">
                  <div className="row summary__item tour__item">
                    <img className="guide__img" src={''} alt="" />

                    <div>
                      <div className="categories__item">Daniela Agami</div>

                      <div className="guide__item">25.02.2017</div>
                    </div>
                  </div>

                  <div className="reviews__item__description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum. Lorem ipsum dolor sit amet,
                    consectetur adipiscing elit. Aenean euismod bibendum laoreet.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-12 side-info-wrapper" style={{ maxWidth: 450 }}>
            <div className="side-info">
              {localTour &&
                localTour.photos && (
                  <Carousel showArrows={true} showStatus={false} showThumbs={false} autoPlay={true} emulateTouch={true}>
                    {localTour.photos.map((photo, index) => (
                      <div className="carouselPhoto" key={index}>
                        <img src={photo.s3Url} alt="" />
                      </div>
                    ))}
                  </Carousel>
                )}
              <div className="overview__pricing">
                <div className="overview__info">
                  <div className="overview__price">
                    <div className="price-review">
                      <span>{`${localTour.groupPrice}${getSymbolFromCurrency(localTour.currency)} per person`}</span>
                      {localTour.privateTourPrice > 0 && (
                        <div
                          className="overview__rating"
                          style={{ cursor: this.state.privateShown ? 'default' : 'pointer', marginTop: 8 }}
                          onClick={() => this.setState({ privateShown: true })}
                        >
                          {this.state.privateShown ? localTour.currency + ' ' + localTour.privateTourPrice : 'See private tour price'}
                        </div>
                      )}
                      <div className="overview__rating" style={{ marginTop: 8 }}>
                        <StarRatingComponent name="rate1" starCount={5} emptyStarColor={'#ebebeb'} value={0} editing={false} />
                        <span className="overview__reviews" style={{ marginLeft: 8 }}>
                          {' '}
                          {localTour.userReviews ? `(${localTour.userReviews.length})` : '(0)'}
                        </span>
                      </div>
                    </div>

                    <button className="overview__price__date-btn" onClick={() => this.handleSeeDatesClick()}>
                      {t('see_dates')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal show={this.state.datesModalOpen} onHide={() => this.closeModal()} id="event-modal" aria-labelledby="ModalHeader">
            <EventDatesModal
              order={this.state.order}
              updateState={this.props.updateState}
              goToActivityBooking={this.goToActivityBooking}
              events={this.state.events}
              modalClose={() => this.closeModal()}
              t={t}
            />
          </Modal>

          {this.renderModal()}
        </div>
      )
    }
  }
}

const enhance = compose(
  translate('overview'),
  graphql(LOCAL_TOUR, {
    name: 'localTour',
    options: props => ({
      variables: {
        id: props.match.params.id
      }
    })
  }),
  graphql(USER_QUERY, {
    name: 'userProfile',
    options: {
      fetchPolicy: 'network-only'
    }
  })
)

export default enhance(ActivityOverview)




// WEBPACK FOOTER //
// src/components/Activity/ActivityOverview.jsx